module.exports = require("less-vars-to-js");